import React from 'react';
import { ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton, scrollToPricing } from './CTAButton';
import { productImage } from '../data/content';
export function FinalCTA() {
  return <section className="bg-brand-navy px-4 py-5 text-center text-white sm:px-6" aria-labelledby="final-heading" data-id="element-43" data-mp="c70z1dii1lq5">
      <h2 id="final-heading" className="mb-2 text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-44" data-mp="83m6jnddjcvt">
        One Last Chance
      </h2>
      <p className="mx-auto mb-2 max-w-xl text-[12px] font-medium leading-snug text-white/85 sm:text-sm" data-id="element-45" data-mp="h6dh7kyfe4me">
        Every week you spend time deciding what to teach. Searching for drills. Building sessions.
        Adapting activities. Organizing progressions. And figuring out what your players should work
        on next. Instead of rebuilding everything from scratch, start with one complete professional
        system that gives you the structure and resources you need.
      </p>
      <p className="mx-auto mb-3 max-w-xl text-[12px] font-bold leading-snug sm:text-sm" data-id="element-46" data-mp="2c4woipnd6ehx">
        Plan faster. Coach with structure. Develop players. Walk onto the court prepared.
      </p>
      <button type="button" onClick={scrollToPricing} className="mb-3 block w-full focus:outline-none focus:ring-2 focus:ring-brand-green" aria-label="Go to the offer section" data-id="element-47" data-mp="2m2ubzaxeg79h">
        <img src={productImage} alt="Pickleball Coach Pro complete 6-in-1 system" className="mx-auto w-full max-w-[200px] object-contain drop-shadow-[0_16px_36px_rgba(0,0,0,0.5)] transition-transform duration-200 hover:scale-[1.02]" data-id="element-48" data-mp="2v427jl8j6tzv" />
      </button>
      <div className="mx-auto mb-3 max-w-sm rounded-lg border border-brand-green/60 bg-white/5 p-2.5" data-id="element-49" data-mp="39s5fh064wfrb">
        <p className="text-[12px] font-extrabold uppercase sm:text-sm" data-id="element-50" data-mp="3errt3apvjy0n">Pickleball Coach Pro™</p>
        <p className="text-[11px] font-bold text-white/85" data-id="element-51" data-mp="3istthuvj2g47">
          Complete 6-in-1 Coaching &amp; Training System + 5 Premium Bonuses
        </p>
        <p className="mt-1 text-[11px] font-semibold text-white/60 line-through" data-id="element-52" data-mp="1jov21wqowif0">
          Regular Price: $97
        </p>
        <p className="text-xl font-extrabold uppercase leading-tight text-brand-green sm:text-2xl" data-id="element-53" data-mp="1en5sklj48ct1">
          Today Only: $27 USD
        </p>
      </div>
      <div className="mx-auto mb-2 max-w-md" data-id="element-54" data-mp="1novtchyw0o3h">
        <CTAButton data-id="element-55" data-mp="1nnu85ko5ql81">🚀 YES! I WANT MY PICKLEBALL COACH PRO™ SYSTEM</CTAButton>
      </div>
      <div className="flex flex-col items-center justify-center gap-0.5 text-[10px] font-bold sm:flex-row sm:gap-3 sm:text-[11px]" data-id="element-56" data-mp="22d04n0vm1xc8">
        <span className="flex items-center gap-1" data-id="element-57" data-mp="2bf9c1hvl1ale">
          <ZapIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-58" data-mp="2bezkvqyswxe4" />
          Immediate Access • Delivered Instantly by Email
        </span>
        <span data-id="element-59" data-mp="h18h3835l7ql">⭐⭐⭐⭐⭐ 4.9/5 — Verified Coach Reviews</span>
        <span className="flex items-center gap-1" data-id="element-60" data-mp="h1rwah1f5i0x">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-61" data-mp="d0oh7wr73q0r" />
          7-Day Money-Back Guarantee
        </span>
      </div>
    </section>;
}